module.exports = [{"constant":true,"inputs":[],"name":"count","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_c","type":"uint256"}],"name":"increase","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"increaseByOne","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]


//////////////////
// WEBPACK FOOTER
// ./src/test.abi.json
// module id = 288
// module chunks = 0